import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import api from '../../API/api';
import Loader from '../panel/loader';


import CustomizedMenus from '../panel/dropdown';
import DocumentViewMenu from '../panel/documentViewMenu';
import { CircularProgress, TablePagination, Typography } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));




export default function CustomizedTables() {

    const [data, setdata] = useState([]);
    const [padingate, setpadingate] = useState([]);
    const [load, setLoad] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        getAdmissionData();
    }, [page, rowsPerPage]);

    const getAdmissionData = () => {
        setLoad(true)
        api.getAdmissionData(page, rowsPerPage).then((res) => {
            console.log(res, 'padingate data');
            setdata(res.data.data)
            setpadingate(res.data.pagination)
            setLoad(false)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }



   

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        // setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
            {load && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <CircularProgress 
                            size={60}
                            thickness={4}
                            sx={{
                                color: '#1a73e8',
                                '& .MuiCircularProgress-circle': {
                                    strokeLinecap: 'round',
                                }
                            }}
                        />
                        <Typography variant="h6" sx={{ color: '#1a73e8' }}>
                            Loading...
                        </Typography>
                    </div>
                </div>
            )}

            <TableContainer>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell align="">Email</StyledTableCell>
                            <StyledTableCell align="">Phone</StyledTableCell>
                            <StyledTableCell align="">Course</StyledTableCell>
                            <StyledTableCell align="">Applied Date</StyledTableCell>
                            <StyledTableCell align="">Documents</StyledTableCell>
                            <StyledTableCell align="">Action</StyledTableCell>
                            <StyledTableCell align="">Remarks</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row,index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.name}
                                    </StyledTableCell>
                                    <StyledTableCell align="">{row.email}</StyledTableCell>
                                    <StyledTableCell align="">{row.phone}</StyledTableCell>
                                    <StyledTableCell align="">{row.applied_course}</StyledTableCell>
                                    <StyledTableCell align="">
                                        {new Date(row.created_at).getDate()
                                            + ", " +
                                            new Date(row.created_at).toLocaleString("default", { month: "long", })
                                            + "-" +
                                            new Date(row.created_at).getFullYear()}
                                    </StyledTableCell>
                                    <StyledTableCell align="">
                                        <DocumentViewMenu data={row} />
                                    </StyledTableCell>
                                    <StyledTableCell align="">
                                        <CustomizedMenus id={row} getAdmissionData={getAdmissionData} />
                                    </StyledTableCell>
                                    <StyledTableCell align="">
                                        {row.remarks}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25,50,100,200]}
                component="div"
                count={padingate.total}
                rowsPerPage={padingate.per_page}
                page={padingate.current_page - 1}
                SelectProps={{
                    inputProps: {
                        'aria-label': 'rows per page',
                    },
                    native: true,
                }}  
                labelRowsPerPage="Rows per page"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
                labelId="demo-simple-select-label"
                nextIconButtonText="Next Page"
                backIconButtonText="Previous Page"
                onPageButtonText="Page"
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}